import type {
  StandardEntityDesignationResponse,
  StandardEntityDesignationCount,
  FieldMappingScreen,
  StandardEntityAttributes,
  FieldMappingGenericError,
} from '../types/field-mapping';

import {
  UPADTE_ACTIVE_FIELD_MAPPING_SCREEN,
  STANDARD_ENTITY_LOADING,
  SET_STANDARD_ENTITY,
  STANDARD_ENTITY_ERROR,
  STANDARD_ENTITY_DESIGNATION_LOADING,
  SET_STANDARD_ENTITY_DESIGNATION,
  SET_LOCAL_STANDARD_ENTITY_DESIGNATION,
  STANDARD_ENTITY_DESIGNATION_ERROR,
  SAVE_STANDARD_FIELD_MAPPING_LOADING,
  SAVE_STANDARD_FIELD_MAPPING_SUCCESS,
  SAVE_STANDARD_FIELD_MAPPING_ERROR,
  CONFIRM_MIGRATE_FIELD_MAPPING_LOADING,
  CONFIRM_MIGRATE_FIELD_MAPPING_SUCCESS,
  CONFIRM_MIGRATE_FIELD_MAPPING_ERROR,
} from 'src/action-creators/field-mapping';

import type {FieldMappingAction} from 'src/action-creators/field-mapping';
import {cloneDesignationsResponse} from '../utils/field-mapping';


export type FieldMappingState = {
  activeScreen: FieldMappingScreen;
  standardEntityAttributes: StandardEntityAttributes;
  standardEntityLoading: boolean;
  standardEntityError: FieldMappingGenericError;
  standardEntityDesignationResponse: StandardEntityDesignationResponse;
  localStandardEntityDesignation: StandardEntityDesignationResponse;
  standardEntityDesignationCount: StandardEntityDesignationCount;
  standardEntityDesignationLoading: boolean;
  standardEntityDesignationError: FieldMappingGenericError;
  saveStandardFieldMappingLoading: boolean;
  saveStandardFieldMappingSuccess: boolean;
  saveStandardFieldMappingError: FieldMappingGenericError;
  confirmMigrateFieldMappingLoading: boolean;
  confirmMigrateFieldMappingSuccess: boolean;
  confirmMigrateFieldMappingError: FieldMappingGenericError;
};

const initialState: FieldMappingState = {
  activeScreen: 'Intro', // 'FieldSelection'
  standardEntityAttributes: {},
  standardEntityLoading: false,
  standardEntityError: null,
  standardEntityDesignationResponse: [],
  localStandardEntityDesignation: [],
  standardEntityDesignationCount: null,
  standardEntityDesignationLoading: false,
  standardEntityDesignationError: null,
  saveStandardFieldMappingLoading: false,
  saveStandardFieldMappingSuccess: false,
  saveStandardFieldMappingError: null,
  confirmMigrateFieldMappingLoading: false,
  confirmMigrateFieldMappingSuccess: false,
  confirmMigrateFieldMappingError: null,
};

export default (
  state: FieldMappingState = initialState,
  action: FieldMappingAction,
): FieldMappingState => {
  switch (action.type) {
    case UPADTE_ACTIVE_FIELD_MAPPING_SCREEN:
      return {
        ...state,
        activeScreen: action.payload,
      };

    case STANDARD_ENTITY_LOADING:
      return {
        ...state,
        standardEntityLoading: true,
      };
    case SET_STANDARD_ENTITY:
      return {
        ...state,
        standardEntityLoading: false,
        standardEntityAttributes: action.payload,
      };
    case STANDARD_ENTITY_ERROR:
      return {
        ...state,
        standardEntityLoading: false,
        standardEntityError: action.payload,
      };

    // @ts-expect-error - TS2678 - Type '"field-mapping/standad-entity-designations-loading"' is not comparable to type '"fieldMapping/updateActiveScreen" | "field-mapping/set-standard-entity" | "field-mapping/standad-entity-loading" | "field-mapping/standad-entity-error"'.
    case STANDARD_ENTITY_DESIGNATION_LOADING:
      return {
        ...state,
        standardEntityDesignationLoading: true,
      };
    // @ts-expect-error - TS2678 - Type '"field-mapping/set-standard-entity-designations"' is not comparable to type '"fieldMapping/updateActiveScreen" | "field-mapping/set-standard-entity" | "field-mapping/standad-entity-loading" | "field-mapping/standad-entity-error"'.
    case SET_STANDARD_ENTITY_DESIGNATION:
      return {
        ...state,
        // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
        standardEntityDesignationResponse: action.payload,
        localStandardEntityDesignation: cloneDesignationsResponse(
          // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
          action.payload,
        ),
        standardEntityDesignationLoading: false,
      };
    // @ts-expect-error - TS2678 - Type '"field-mapping/set-local-standard-entity-designations"' is not comparable to type '"fieldMapping/updateActiveScreen" | "field-mapping/set-standard-entity" | "field-mapping/standad-entity-loading" | "field-mapping/standad-entity-error"'.
    case SET_LOCAL_STANDARD_ENTITY_DESIGNATION:
      return {
        ...state,
        // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
        localStandardEntityDesignation: action.payload,
      };
    // @ts-expect-error - TS2678 - Type '"field-mapping/standad-entity-designations-error"' is not comparable to type '"fieldMapping/updateActiveScreen" | "field-mapping/set-standard-entity" | "field-mapping/standad-entity-loading" | "field-mapping/standad-entity-error"'.
    case STANDARD_ENTITY_DESIGNATION_ERROR:
      return {
        ...state,
        // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
        standardEntityDesignationError: action.payload,
        standardEntityDesignationLoading: false,
      };

    // @ts-expect-error - TS2678 - Type '"field-mapping/save-standard-field-mapping-loading"' is not comparable to type '"fieldMapping/updateActiveScreen" | "field-mapping/set-standard-entity" | "field-mapping/standad-entity-loading" | "field-mapping/standad-entity-error"'.
    case SAVE_STANDARD_FIELD_MAPPING_LOADING:
      return {
        ...state,
        saveStandardFieldMappingLoading: true,
        saveStandardFieldMappingSuccess: false,
        saveStandardFieldMappingError: null,
      };
    // @ts-expect-error - TS2678 - Type '"field-mapping/save-standard-field-mappin-success"' is not comparable to type '"fieldMapping/updateActiveScreen" | "field-mapping/set-standard-entity" | "field-mapping/standad-entity-loading" | "field-mapping/standad-entity-error"'.
    case SAVE_STANDARD_FIELD_MAPPING_SUCCESS:
      return {
        ...state,
        saveStandardFieldMappingLoading: false,
        saveStandardFieldMappingSuccess: true,
      };
    // @ts-expect-error - TS2678 - Type '"field-mapping/save-standard-field-mappin-error"' is not comparable to type '"fieldMapping/updateActiveScreen" | "field-mapping/set-standard-entity" | "field-mapping/standad-entity-loading" | "field-mapping/standad-entity-error"'.
    case SAVE_STANDARD_FIELD_MAPPING_ERROR:
      return {
        ...state,
        saveStandardFieldMappingLoading: false,
        // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
        saveStandardFieldMappingError: action.payload,
      };

    // @ts-expect-error - TS2678 - Type '"field-mapping/confirm-migrate-field-mapping-loading"' is not comparable to type '"fieldMapping/updateActiveScreen" | "field-mapping/set-standard-entity" | "field-mapping/standad-entity-loading" | "field-mapping/standad-entity-error"'.
    case CONFIRM_MIGRATE_FIELD_MAPPING_LOADING:
      return {
        ...state,
        confirmMigrateFieldMappingLoading: true,
      };
    // @ts-expect-error - TS2678 - Type '"field-mapping/confirm-migrate-field-mapping-success"' is not comparable to type '"fieldMapping/updateActiveScreen" | "field-mapping/set-standard-entity" | "field-mapping/standad-entity-loading" | "field-mapping/standad-entity-error"'.
    case CONFIRM_MIGRATE_FIELD_MAPPING_SUCCESS:
      return {
        ...state,
        confirmMigrateFieldMappingLoading: false,
        confirmMigrateFieldMappingSuccess: true,
      };
    // @ts-expect-error - TS2678 - Type '"field-mapping/confirm-migrate-field-mapping-error"' is not comparable to type '"fieldMapping/updateActiveScreen" | "field-mapping/set-standard-entity" | "field-mapping/standad-entity-loading" | "field-mapping/standad-entity-error"'.
    case CONFIRM_MIGRATE_FIELD_MAPPING_ERROR:
      return {
        ...state,
        confirmMigrateFieldMappingLoading: false,
        // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
        confirmMigrateFieldMappingError: action.payload,
      };
  }
  return state;
};
